module.exports = __webpack_public_path__ + "static/media/sy_jiaogechenggong.8484d30c.png";